<template>
  <div class="nav-theme-dark nav-layout-left">
    <a-layout style="min-height: 100vh">
      <a-layout-sider
        theme="dark"
        :trigger="null"
        collapsible
        v-model="collapsed"
        width="256px"
      >
        <router-link class="logo" to="/">
          <img
            v-if="userInfo && userInfo.userLogoUrl"
            :src="userInfo.userLogoUrl"
            height="40px"
            style="border-radius: 50%;"
            alt="logo"
          />
          <img v-else src="../assets/logo.png" height="32px" alt="logo"/>
          <div class="app-name">
            <div class="shot-name">{{ $t('layouts.appShortName') }}</div>
            <div>{{ $t('layouts.appName') }}</div>
          </div>
        </router-link>
        <SideMenu theme="dark" :collapsed="collapsed"></SideMenu>
      </a-layout-sider>
      <a-layout :class="['layout-right', collapsed ? 'side-fold' : '']">
        <div class="layout-right-container">
          <a-layout-header :class="collapsed ? 'side-fold' : ''">
            <a-icon
              class="tigger"
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="collapsed = !collapsed"
            ></a-icon>
            <Header></Header>
          </a-layout-header>

          <a-layout-content>
            <MultiTab></MultiTab>
            <PageHead></PageHead>
            <RouteView></RouteView>
          </a-layout-content>

          <!-- <a-layout-footer style="text-align: center">
            <Footer></Footer>
          </a-layout-footer>   -->
        </div>
      </a-layout>
    </a-layout>
    <CloudAuthExpiredDeviceModal
      ref="cloudAuthExpiredDeviceModal"
      title="云服务临期设备"
      :visible="showExpiredModal"
      :loading="expiredLoading"
      :table-data="tableData"
      @cancel="handleExpiredCancel"
      @ok="handleExpiredOk"
    />
  </div>
</template>

<script>
import RouteView from './RouteView'
import Header from './Header'
import Footer from './Footer'
import SideMenu from './SideMenu'
import CloudAuthExpiredDeviceModal from './components/CloudAuthExpiredDeviceModal'
import PageHead from '@/components/PageHead'
import { mapState } from 'vuex'
import { GetDeviceListForCloudExpired } from '../api/deviceMana'
import { getNowFormatDate } from '../utils/utils'

export default {
  name: 'BasicLayout',
  components: {
    RouteView,
    Header,
    // Footer,
    SideMenu,
    PageHead,
    CloudAuthExpiredDeviceModal
  },
  data() {
    return {
      showExpiredModal: false,
      expiredLoading: false,
      collapsed: false,
      tableData:[]
    }
  },
  created() {
    this.handleCheckDeviceAuth()
  },
  computed: {
    ...mapState(['userInfo', 'lang'])
  },
  mounted() {
    if (this.lang === 'zh_CN') {
      document.title = '智能门禁系统'
    }
    if (this.lang === 'en_US') {
      document.title = 'Intelligent ACS'
    }
  },
  methods: {
    handleCheckDeviceAuth() {
      GetDeviceListForCloudExpired().then(res => {
        if (res.data.success && res.data.collection){
          let data = res.data.collection
          if (data && data.length > 0){
            // 判断今日是否提醒过
            let day = getNowFormatDate()
            let today = localStorage.getItem(day)
            console.log(today,'today')
            if (!today){
              this.tableData = data
              this.showExpiredModal = true
              localStorage.setItem(day,"1")
            }
          }
        }
      })
    },
    handleExpiredOk(){
      this.handleExpiredCancel()
      this.$router.push({ name: 'rechargeIndex' });
    },
    handleExpiredCancel(){
      this.showExpiredModal = false
      this.tableData = []
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: '华文琥珀';
  src: url('../assets/fonts/hwhp.ttf');
  font-weight: normal;
  font-style: normal;
}

.tigger {
  padding: 0 20px;
  line-height: 64px;
  font-size: 20px;
}

.tigger:hover {
  background: #eee;
}

.logo {
  display: block;
  height: 64px;
  line-height: 64px;
  text-align: center;
  overflow: hidden;
  background: #002140;
}

.logo .app-name {
  vertical-align: middle;
  display: inline-block;
  color: #fff;
  font-size: 15px;
  margin: 0 0 0 12px;
}

.shot-name {
  font-family: '华文琥珀';
  background: linear-gradient(to right, #00B5FA, #0076A8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 20px;
}

.app-name div {
  line-height: 20px !important;
}

.nav-theme-dark >>> .logo {
  color: #fff;
}

.ant-layout-sider {
  position: fixed;
  height: 100%;
  z-index: 106;
  min-height: 100vh;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
}

.ant-layout.layout-right {
  padding-left: 256px;
  min-height: 100vh;
  transition: width 0.2s;

  /* min-width: 1366px; */
  overflow-x: auto !important;
  /* overflow-x: unset !important; */
}

.ant-layout.layout-right.side-fold {
  padding-left: 80px;
  min-height: 100vh;
}

.layout-right-container {
  height: 100%;
  min-width: 1110px;
  overflow-x: auto;
}

.ant-layout-header {
  background: #fff;
  padding: 0;
  border-bottom: 1px solid #e8e8e8;
  width: 100%;
}

.ant-layout-content {
  height: calc(100% - 64px);
  position: relative;
}
</style>
